import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AnnouncementCard } from '@/components/announcements/AnnouncementCard';
import { useAnnouncements } from '@/data/useAnnouncements';

/**
 * operator-panel-v2 T2.7, fleet-driver-pay T5.3: the operator's announcements at the top of the portal
 * (`my_announcements`, re-read on focus, every five minutes and when the inbox changes the read state).
 * One shared `AnnouncementCard` per notice in the reader's language (kicker, icon and tone per kind, the
 * optional link). A dismissible notice has a close button and the dismissal is stored on the server for
 * the user (`announcement_dismiss`), on every device; a non-dismissible one stays until its window ends.
 * Renders nothing when there is nothing to show. The full history lives at /announcements, where the
 * banner stays out (and reads nothing): the page already shows the same cards.
 */
export function AnnouncementBanner({ enabled = true }: { enabled?: boolean }) {
  const { t } = useTranslation();
  const onInbox = useLocation().pathname === '/announcements';
  const { items, dismiss } = useAnnouncements(enabled && !onInbox);
  if (onInbox || items.length === 0) return null;
  return (
    <div className="mb-4 flex flex-col gap-3" role="region" aria-label={t('announcements.label')}>
      {items.map((a) => (
        <AnnouncementCard key={a.id} row={a} onDismiss={a.dismissible ? () => dismiss(a.id) : undefined} />
      ))}
    </div>
  );
}
